<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-4 title="My account" subtitle="My account" :center="true" />
    <!-- breadcrumb end -->

    <!-- login area start -->
    <login-area />
    <!-- login area end -->
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/pinia/useAuthStore";
import { storeToRefs } from "pinia";
const { isAuth } = storeToRefs(useAuthStore());
const localePath = useLocalePath();

if (isAuth.value) {
  navigateTo(localePath("/"));
}
useSeoMeta({ title: "Login Page" });
</script>
